var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',_vm._g({class:['global__button-black', _vm.size],attrs:{"disabled":_vm.isDisabled}},_vm.$listeners),[(_vm.loading)?_c('i',{staticClass:"el-icon-loading"}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }